export default {
  SIGNS_PRACTICE: "चिन्ह अभ्यास",
  TIMESUP: "समय समाप्त",
  START_GAME: "गेम शुरू करें!",
};
